import { Link, Typography } from '@material-ui/core';
import { formatDate } from '@superdispatch/dates';
import { Inline, Stack } from '@superdispatch/ui';
import { Box, Button, DescriptionItem, TextBox } from '@superdispatch/ui-lab';
import { useLocation } from 'react-router-dom';
import { formatCurrency } from 'shared/helpers/IntlHelpers';
import { openExternalURL } from 'shared/helpers/URLHelpers';
import { SubscriptionDetailsDTO } from 'shared/modules/subscription/SubscriptionDTO';
import { LinkAnchor } from 'shared/routing/Links';

interface SettingsSubscriptionPlanProps {
  subscriptionDetails: SubscriptionDetailsDTO;
  onReactivationSuccess?: () => void;
}

export function SettingsSubscriptionPlan({
  subscriptionDetails,
}: SettingsSubscriptionPlanProps) {
  const location = useLocation();

  const upcomingBillingDate =
    subscriptionDetails.subscription?.current_term_end;

  const isSubscriptionOnLitePlan =
    subscriptionDetails.subscription?.plan?.name === 'lite';

  const isSubscriptionPage = location.pathname.includes('subscription');

  return (
    <Stack space="small">
      <Stack space="xxsmall">
        <Inline verticalAlign="bottom">
          <Typography display="inline" variant="h3">
            Plan
          </Typography>

          <Box height="24px">
            <Link
              target="_blank"
              rel="noreferrer noopener"
              href="https://support.superdispatch.com/hc/articles/35612448514195-How-To-Manage-Your-Subscription-Plan-In-Carrier-TMS"
              color="primary"
            >
              Learn More
            </Link>
          </Box>
        </Inline>

        {!isSubscriptionOnLitePlan ? (
          <Typography>
            Your subscription renew on{' '}
            {formatDate(upcomingBillingDate, { variant: 'ShortDate' })}
          </Typography>
        ) : (
          !!upcomingBillingDate && (
            <Typography>
              Your subscription will end on{' '}
              {formatDate(upcomingBillingDate, { variant: 'ShortDate' })}
            </Typography>
          )
        )}
      </Stack>

      <Stack space={['small', 'xsmall']}>
        <DescriptionItem label="Type:">
          Pro ({formatCurrency(subscriptionDetails.subscription?.plan?.amount)}
          /mo)
        </DescriptionItem>

        <DescriptionItem label="Drivers:">
          <Inline space="xsmall" verticalAlign="center">
            {subscriptionDetails.subscription?.plan?.quantity}

            {isSubscriptionPage && isSubscriptionOnLitePlan && (
              <LinkAnchor color="textSecondary" to="/users">
                Manage Drivers
              </LinkAnchor>
            )}
          </Inline>
        </DescriptionItem>
        {subscriptionDetails.subscription?.plan?.amount != null && (
          <DescriptionItem label="Discount for this month:">
            {formatCurrency(subscriptionDetails.subscription?.plan?.amount)}
          </DescriptionItem>
        )}
        <DescriptionItem label="Total price:">
          {formatCurrency(subscriptionDetails.subscription?.plan?.amount)}
          /mo{' '}
          <TextBox color="secondary" variant="body">
            + tax if applicable
          </TextBox>
        </DescriptionItem>
      </Stack>

      {!isSubscriptionPage && isSubscriptionOnLitePlan && (
        <Button
          variant="neutral"
          onClick={() => {
            openExternalURL('/tms/users');
          }}
        >
          Manage Drivers
        </Button>
      )}
    </Stack>
  );
}
